export const squareList = [
  {show: true, id: 1,},
  {show: true, id: 2,},
  {show: true, id: 3,},
  {show: true, id: 4,},
  {show: true, id: 5,},
  {show: true, id: 6,},
  {show: true, id: 7,},
  {show: true, id: 8,},
  {show: true, id: 9,},
  {show: true, id: 10,},
  {show: true, id: 11,},
  {show: true, id: 12,},
  {show: true, id: 13,},
  {show: true, id: 14,},
  {show: true, id: 15,}
]